'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOKING_TIME_CONFLICT = exports.BOOKING_TIME_CONFLICT = 'meeting booked from underneath';

var INVALID_DOMAIN_FOR_LINK = exports.INVALID_DOMAIN_FOR_LINK = 'INVALID_DOMAIN_FOR_LINK';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/constants/errors.js
// module id = 197
// module chunks = 0